module.exports = __webpack_public_path__ + "img/shrine-2-60.f3b74840.jpg";